import { useTheme } from "next-themes";
import { Toaster as Sonner, toast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      closeButton
      toastOptions={{
        closeButton: true,
        style: {
          background: 'hsl(var(--glass-bg) / 0.85)',
          backdropFilter: 'blur(24px) saturate(180%)',
          WebkitBackdropFilter: 'blur(24px) saturate(180%)',
          border: '1px solid hsl(var(--glass-border) / 0.20)',
          color: 'white',
          boxShadow: '0 8px 32px hsl(0 0% 0% / 0.40)',
        },
        classNames: {
          toast:
            "group toast pointer-events-auto",
          description: "!text-white/60",
          actionButton: "group-[.toast]:bg-accent group-[.toast]:text-accent-foreground",
          cancelButton: "group-[.toast]:bg-white/10 group-[.toast]:text-white/70",
          closeButton: "!text-white/50 !border-white/10 !bg-white/5",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
